import styles from "./Logo.module.css";
import logo from "../../../images/logo.svg";
import { Link } from "react-router-dom";

const Logo = ({ size }) => {
    return (
        <Link to="/">
            <div className={`${styles.logoWrapper} ${size==='medium' ? styles.medium : ''}`}>
                <img src={logo} alt="logo" lazy="true" />
            </div>
        </Link>
    )
}

export default Logo;